export const ENV = 'dev';
export const GENERIC_URL = {
  local: {
    api: 'http://localhost:6699/',
    socket: 'https://lobby-staging.ambpoker-api.com/',
    ambslot: 'https://web-api-staging.ambslot-api.com/',
    bonus: 'https://angpow-dev.pgslot.cc/',
    result: 'http://localhost:8080/',
    resultAmbslot: 'https://report-staging.ambslot.com/result/',
  },
  dev: {
    api: 'https://web-api-staging.ambpoker-api.com/',
    socket: 'https://lobby-staging.ambpoker-api.com/',
    bonus: 'https://angpow-dev.pgslot.cc/',
    ambslot: 'https://web-api-staging.ambslot-api.com/',
    result: 'https://staging-report.ambpoker.com/',
    resultAmbslot: 'https://report-staging.ambslot.com/result/',
  },
  sit: {
    api: 'https://api-sit.ambgames.app/api/',
    socket: 'wss://sksit-lobby.ambgames.app/',
  },
  prod: {
    api: 'https://web-api-prod.ambpoker-api.com/',
    socket: 'https://lobby.ambpoker-api.com',
    bonus: 'https://rp99qvzxw0.execute-api.ap-southeast-1.amazonaws.com/angpow-prod/',
    ambslot: 'https://web-api-prod.ambslot-api.com/',
    result: 'https://report.ambpoker.com/',
    resultAmbslot: 'https://report.ambslot.com/result/',
  },
};

export const BASE_URL = GENERIC_URL[ENV].api;
export const SOCKET_URL = GENERIC_URL[ENV].socket;
export const BONUS_URL = GENERIC_URL[ENV].bonus;
export const RESULT_URL = GENERIC_URL[ENV].result;
export const RESULT_AMBSLOT_URL = GENERIC_URL[ENV].resultAmbslot;
export const AMBSLOT_URL = GENERIC_URL[ENV].ambslot;
export const M_GET = 'GET';
export const M_POST = 'POST';
export const M_PUT = 'PUT';
export const M_DELETE = 'DELETE';

export const LOGIN = 'auth/login/agent';
export const REFRESH_TOKEN = 'auth/refresh';
export const FIND_SUBPASS = 'auth/secure/find';
export const CREATE_SUBPASS = 'auth/secure/create';
export const VER_SUBPASS = 'auth/secure/verify';
export const USERS = 'user/list';
export const GET_USERS_DOWNLINE = 'user/search';
export const USERS_HISTORY = 'user/history';
export const USERS_BALANCE = 'user/balance';
export const USERS_SUBAGENT = 'user/subagent/list';
export const USERS_ACTIVATE = 'user/activate';
export const GET_PROFILE = 'user/profile/get/';
export const UPDATE_PROFILE = 'user/profile/update/';
export const UPDATE_IP = 'user/update/ip';
export const RESET_PASSWORD = 'user/password/reset';
export const UPDATE_COMMISSION = 'user/commission';
export const USERS_GENERATE = 'user/generate';
export const USERS_CREATE = 'user/register';
export const GET_PTSUBAGENT = 'user/ptsubagent';
export const CHECK_PREFIX = 'prefix';
export const GET_GAMES = 'game/list';
export const GET_MAINTENANCE_GAMES = 'game/list/maintenance';
export const MAINTENANCE_GAME = 'game/maintenance';
export const GAME_UPDATE = 'game/update';
export const WINLOSE_REPORT = 'report/winlose/simple/v3';
export const WINLOSE_REPORT_NEW = 'report/winlose/simple/new';
export const WINLOSE_REPORT_ELASTIC = 'report/winlose/elastic';
export const WINLOSE_REPORT_LOGS = 'report/winlose/simple/logs/v2';
export const WINLOSE_DETAIL = 'report/winlose/detail';
export const WINLOSE_DETAIL_LOGS = 'report/winlose/detail/logs';
export const GAME_REPORT = 'report/game';
export const WINLOSE_RESULT = 'result';
export const GET_PRELOAD = 'preload/list';
export const CREATE_PRELOAD = 'preload/create';
export const UPDATE_PRELOAD = 'preload/update';
export const DELETE_PRELOAD = 'preload/delete';
export const UPDATE_PERMISSION = 'user-permission/update';
export const PLAYER_ONLINE = 'player/online';
export const PLAYER_ONLINE_LIST = 'player/online/list';
export const GET_TRANSFER_KEY = 'partner/transfer/fetch';
export const UPDATE_TRANSFER_KEY = 'partner/transfer/edit';
export const GET_SEAMLESS_KEY = 'partner/seamless/fetch';
export const UPDATE_SEAMLESS_KEY = 'partner/seamless/edit';
export const INVOICE_REPORT = 'report/invoice';
export const GENERATE_EXCEL_INVOICE = 'report/invoice/excel';
export const TRANSACTION_AMBPOKER = 'version/transaction';
export const NEW_TRANSACTION_AMBPOKER = 'version/transaction-url';
export const FECTH_AGENT = 'report/fetchAgent';

export const TRANSFER = 'wallet/credit/refill';
export const WITHDRAW = 'wallet/credit/deduct';
export const GET_STATEMENT = 'wallet/statement';
export const GET_STATEMENT_DETAIL = 'wallet/statement/detail';
export const CREATE_2FA = 'preauth/twofactor/setup';
export const VERIFY_2FA = 'preauth/twofactor/verify';

// Bonus
export const BONUS_GET_SUB_USERS = 'key/fetch';
export const BONUS_GET_MAIN_USER = 'key/fetch/product';
export const BONUS_GET_LISTS_SYSTEM = 'agent/generalConfig/fetch';
export const BONUS_SELECT_SYSTEM = 'agent/generalConfig/select';
export const BONUS_UPDATE_CONFIGS = 'agent/generalConfig/update';
export const BONUS_SELECT_ACTIVATE_SYSTEM = 'agent/generalConfig/activeFeature';
export const BONUS_ACTIVATE_ALL_SYSTEM_BY_AGENT = 'agent/generalConfig/active';
export const BONUS_ACTIVATE_GLOBALE_SYSTEM = 'agent/generalConfig/activeGlobal';
export const BONUS_ACTIVATE_MAINTENANCE = 'agent/generalConfig/maintenance';
export const BONUS_ACTIVATE_MAINTENANCE_AGENT = 'agent/generalConfig/maintenanceAgent';
export const BONUS_GET_HISTORY_CONFIG = 'agent/generalConfig/history/fetch';
export const BONUS_DELETE_HISTORY_CONFIG = 'agent/generalConfig/history/delete';
export const BONUS_GET_LOG = 'agent/report/angpow';
export const BONUS_GET_LOG_DETAIL = 'agent/report/angpowTransaction';

// Suggestion
export const SUGGESTION_GET_TOPIC = 'suggestion/fetch';
export const SUGGESTION_CREATE_TOPIC = 'suggestion/create';
export const SUGGESTION_EDIT_TOPIC = 'suggestion/edit';
export const SUGGESTION_DELETE_TOPIC = 'suggestion/delete';
export const SUGGESTION_GET_REPORT = 'suggestion/report';
export const SUGGESTION_SUBMIT = 'suggestion/submit';
export const SUGGESTION_SHEET = 'suggestion/sheet';

// Dashboard
export const DASHBOARD = 'dashboard';
export const REPORT_DASHBOARD = 'report/dashboard';

// Announcement
export const ANNOUNCEMENT_CREATE = 'announcement/create';
export const ANNOUNCEMENT_UPDATE = 'announcement/update';
export const ANNOUNCEMENT_LIST = 'announcement/list';
export const ANNOUNCEMENT_DELETE = 'announcement/delete';

// AgentBanner
export const AGENT_BANNER_CREATE = 'agentbanner/create';
export const AGENT_BANNER_UPDATE = 'agentbanner/update';
export const AGENT_BANNER_LIST = 'agentbanner/list';
export const AGENT_BANNER_DELETE = 'agentbanner/delete';

export const BANK_ACCOUNT_LISTBANK = 'bankaccount/listbank';
export const BANK_ACCOUNT_CREATE = 'bankaccount/create';

export const BANKACCOUNT_CREATE = 'bankaccount/create';
export const BANKACCOUNT_LIST = 'bankaccount/list';
export const BANKACCOUNT_UPDATE = 'bankaccount/update';
export const BANKACCOUNT_DELETE = 'bankaccount/delete';
export const BANK_NAME_LIST = 'bankaccount/bank/list';

// Currency
export const CURRENCY_RATE = 'wallet/rate';

// Admin
export const FIND_USER_SUBPASS = 'admin/find-user';
export const RESET_SUBPASS = 'admin/reset';
export const FETCH_RESET_LOG = 'admin/fetchlog-subpass';
export const FETCH_RESETPASS_LOG = 'admin/fetchlog';
export const FETCH_LOG_ACTIVITY = 'admin/activity-log';
export const FETCH_COMMISSION_LOG = 'admin/commissionlog';

// Document Download
export const DOCUMENT_DOWNLOAD = 'document/download';
export const GENERATE_PDF_INVOICE = 'invoice/exportpdf';
export const DOCUMENT_FETCH = 'document/fetch';
export const DOCUMENT_CREATE = 'document/create';
export const DOCUMENT_UPDATE = 'document/create';
export const DOCUMENT_DELETE = 'document/delete';

// Round
export const FEATCH_ROUND = 'report/round/pending';
export const ROUND_CANCEL = 'dealing/cancel';
export const ROUND_CANCEL_LIST = 'dealing/cancel/list';
export const ROUND_CANCEL_LOG = 'report/round/cancel';
export const REPORT_ROUND_LOG = 'report/round/log';
export const UPDATE_STATUS = 'dealing/status';

// Marketing
export const MARKETING_FETCH = 'marketing/fetch';
export const UPDATE_FEATURE = 'marketing/setfeature';

// CryptoAccount
export const CRYPTO_FETCH = 'cryptoaccount/fetch';
export const CRYPTO_CREATE = 'cryptoaccount/create';
export const CRYPTO_UPDATE = 'cryptoaccount/update';
export const CRYPTO_DELETE = 'cryptoaccount/DELETE';

export const AMBPOKER_SECRET = 'b34f63f8733328b5c6c9a98354f70137';

// public key
export const PUBLIC_KEY_HEADER = '-----BEGIN PUBLIC KEY-----MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDuqq38PkSc0n3IQ8Oe+8siwuv4UwD7Usyn9/KN0n+ZtiRXDpkXeyDLuXqr8O3HLch4Hgj6BmgUIXH9GQ6obVlnseY1x2lz4EbRq8W3VFmQsh+bmRSdCkMbCRvc6iO4mWPRkpBkIstU5R3e65/HyCWEZYRPPgGu35YyAAHfz9+GUwIDAQAB-----END PUBLIC KEY-----';
